import React, { useEffect } from 'react'
import View from '../../atoms/view'
import theme from '../../../theme'
import { P } from '@modul-connect/shared/components/atoms/text'
import { minHeight } from '@mui/system'


export const CustomModal2 = ({ openModal, title, children, primaryButton, secondaryButton, onSave, onCancel, disabled, teamAlreadyExist }) => {
  if (!openModal) return null

  const S = styles()


  return (
    <View extend={S.background_overlay}>
      <View extend={S.modal_container}>
        <View extend={S.modal_header}>
          <View extend={S.text_title}>{title}</View>
        </View>
        <View extend={S.modal_body}>
          {teamAlreadyExist && (
            <P noPadding style={{ color: theme.colors.error }}>
            Team already exists.
            </P>
          )}
          <View style={{ minHeight: 30 }}>
            {children}
          </View>
          <View extend={S.modal_devider}></View>

          <View extend={S.modal_buttons}>
            <View extend={S.save_button({ disabled })} onClick={disabled ? undefined : onSave}>
              <View extend={() => S.button_text({ isCancel: false })}>{primaryButton}</View>
            </View>
            {secondaryButton && (
            <View extend={S.cancel_button} onClick={onCancel}>
              <View extend={() => S.button_text({ isCancel: true })}>{secondaryButton}</View>
            </View>
            )}
          </View>
        </View>
      </View>
    </View>
  )
}

/* ───────────────────────────── Styles ───────────────────────────── */

export const styles = () => ({
  background_overlay: () => ({
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.36)', 
    zIndex: 999, 
  }),
  modal_container: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 0px 24px',
    gap: '16px',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    left: '50%',
    top: '50%',
    width: '463px',
    minHeight: '195px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.08)',
    borderRadius: '4px',
    zIndex: 10,
    
  }),
  modal_header: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '12px 24px',
    gap: '4px',
    width: '463px',
    height: '46px',
    background: '#EDEDED',
    flexShrink: 0,  
  }),
  text_title: ({ theme }) => ({
    width: '415px',
    height: '22px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '22px'
  }),
  modal_body: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 24px',
    gap: '16px',
    width: '463px',
    minHeight: '109px',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0
  }),
  modal_input: ({ theme }) => ({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 12px',
    gap: '16px',
    width: '415px',
    height: '36px',
    border: '1px solid #CACACA',
    marginBottom: 0,
    borderRadius: '4px',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
    backgroundColor: 'transparent'
  }),
  modal_devider: ({ theme }) => ({
    width: '415px',
    height: '0px',
    border: '1px solid #D5D5D5',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0
  }),
  modal_buttons: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0px',
    width: '415px',
    minHeight: '41px',
    flex: 'none',
    order: 2,
    alignSelf: 'stretch',
    flexGrow: 0,
    gap: 10,
  }),
  save_button: ({ disabled }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 66px',
    gap: '10px',
    width: '169px',
    height: '35px',
    background: disabled ? '#494949' : theme.colors.buttonBackground,
    borderRadius: '4px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
    cursor: disabled ? 'default' : 'pointer'
  }),
  button_text: ({ isCancel }) => ({
    width: isCancel ? '53px' : '37px',
    height: '19px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
    color: isCancel ? '#404040' : '#FDFDFD',
    flex: 'none',
    order: 0,
    flexGrow: 0
  }),
  cancel_button: ({ theme }) => ({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '8px 20px',
    gap: '12px',
    width: '93px',
    height: '35px',
    border: '1px solid #404040',
    borderRadius: '4px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
    cursor: 'pointer'
  })



})
